import { addCaseLoad, loadCaption, parseWeightText, removeCaseLoad, setCaseLoadWeight, unusedLoadIds } from "/src/features/stageEditor/caseLoad.ts";

function fillPick(pick, loads) {
  const ids = unusedLoadIds(loads);
  pick.replaceChildren();
  for (const id of ids) {
    const option = document.createElement("option");
    option.value = id;
    option.textContent = loadCaption(id);
    pick.append(option);
  }
  pick.disabled = ids.length === 0;
}

export function renderCaseLoads(loads, apply) {
  const list = document.getElementById("load-list");
  const pick = document.getElementById("load-pick");
  list.replaceChildren();
  for (const entry of loads) {
    const row = document.createElement("div");
    row.className = "load-row";
    const label = document.createElement("p");
    label.textContent = loadCaption(entry.id);
    const weight = document.createElement("input");
    weight.type = "text";
    weight.inputMode = "numeric";
    weight.autocomplete = "off";
    weight.className = "load-weight";
    weight.value = String(entry.weight);
    weight.setAttribute("aria-label", `${entry.id}の重み`);
    const commit = () => {
      const next = parseWeightText(weight.value);
      if (next === null) {
        weight.value = String(entry.weight);
        return;
      }
      if (next === entry.weight) return;
      apply(setCaseLoadWeight(loads, entry.id, next));
    };
    weight.addEventListener("change", commit);
    weight.addEventListener("blur", commit);
    const remove = document.createElement("button");
    remove.type = "button";
    remove.textContent = "外す";
    remove.addEventListener("click", () => apply(removeCaseLoad(loads, entry.id)));
    row.append(label, weight, remove);
    list.append(row);
  }
  fillPick(pick, loads);
}

export function bindCaseLoads(applyFromPick) {
  document.getElementById("load-add").addEventListener("click", () => {
    applyFromPick(document.getElementById("load-pick").value);
  });
}
